var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "ProRataModal", role: "dialog", "data-backdrop": "static" },
    },
    [
      _c("div", { staticClass: "modal-dialog upgrade-account-modal" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _c("div", { staticClass: "modal-header upgradeModal-bgcolor" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-target": "#UpgradeModal" },
                on: { click: _vm.closePopup },
              },
              [_vm._v(" × ")]
            ),
            _vm._m(0),
          ]),
          _c("div", { staticClass: "modal-body confirm-body row m-0" }, [
            _c("div", { staticClass: "col-sm-12" }, [
              _vm._v("Please check the details to proceed:"),
            ]),
            _c("div", { staticClass: "border-box col-sm-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12 d-flex" }, [
                  _c("div", { staticClass: "wd-200" }, [
                    _vm._v("Currently Active Services:"),
                  ]),
                  _c("div", [
                    _c(
                      "ol",
                      _vm._l(_vm.proRataData.planInfo, function (data, index) {
                        return _c("li", { key: index }, [
                          _c("div", [_vm._v(_vm._s(data.name))]),
                          _c("div", [
                            _vm._v(
                              "Expiration Date - " +
                                _vm._s(_vm._f("dateFormat")(data.valid_until))
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._m(1),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12 d-flex" }, [
                  _c("div", { staticClass: "wd-200" }, [_vm._v("Note:")]),
                  _c("div", {}, [
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "As you activate the " +
                            _vm._s(_vm.serviceSelected.name) +
                            " Package the current active Services will be canceled and a pro rated amount will be credited towards the purchase price of the Package."
                        ),
                      ]),
                      _c("li", [
                        _vm._v(
                          "The new starting Date of the " +
                            _vm._s(_vm.serviceSelected.name) +
                            " Package will be " +
                            _vm._s(_vm._f("dateFormat")(_vm.todayDate)) +
                            "."
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._m(2),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12 d-flex" }, [
                  _c("div", { staticClass: "wd-200" }, [
                    _vm._v("Credit Amount:"),
                  ]),
                  _c("div", {}, [
                    _vm._v("$" + _vm._s(_vm.proRataData.creditPrice)),
                  ]),
                ]),
                _vm._m(3),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12 d-flex" }, [
                  _c("div", { staticClass: "wd-200" }, [
                    _vm._v("Package Price:"),
                  ]),
                  _c("div", {}, [
                    _vm._v("$" + _vm._s(_vm.serviceSelected.price)),
                  ]),
                ]),
                _vm._m(4),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12 d-flex" }, [
                  _c("div", { staticClass: "wd-200" }, [
                    _vm._v("Final Price:"),
                  ]),
                  Math.sign(
                    _vm.serviceSelected.price - _vm.proRataData.creditPrice
                  ) === -1
                    ? _c("div", [
                        _vm._v(
                          "$0 (Credit $" +
                            _vm._s(
                              Math.abs(
                                _vm.serviceSelected.price -
                                  _vm.proRataData.creditPrice
                              )
                            ) +
                            ". Please contact "
                        ),
                        _c("a", { attrs: { href: "mailto:ramshelp@ul.com" } }, [
                          _vm._v("RAMSHelp@ul.com"),
                        ]),
                        _vm._v(" for support)"),
                      ])
                    : _c("div", {}, [
                        _vm._v(
                          "$" +
                            _vm._s(
                              _vm.serviceSelected.price -
                                _vm.proRataData.creditPrice
                            )
                        ),
                      ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "modal-footer cancelModal-bgcolor" }, [
            _c("div", { staticClass: "col-xs-12 pl-0 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn emergo-white-button custom-wd-160",
                  on: {
                    click: function ($event) {
                      return _vm.closePopup()
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn emergo-green-button custom-wd-160",
                  on: {
                    click: function ($event) {
                      return _vm.continueUpgrade()
                    },
                  },
                },
                [_vm._v(" Continue ")]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-title" }, [
      _c("div", { staticClass: "upgrade-service-para fw-400" }, [
        _vm._v("Pro Rata Pricing"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [_c("hr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }